import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../stores/applications/selectors';
import { hideGroups } from '../../stores/auth/selectors';
import { groupOptions } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import { selectAll, unselectAll } from '../../stores/tables/actionCreators';
import { userOptions } from '../../stores/users/selectors';
import TableColumn from '../table/TableColumn';
import TableFilterableColumn from '../table/TableFilterableColumn';
import TableHead from '../table/TableHead';
import TableSelectionColumn from '../table/TableSelectionColumn';
import TableSortableColumn from '../table/TableSortableColumn';

interface Props extends LocalizeContextProps {
  count?: number;
  refresh: () => void;
  ids: string[];
  hideGroups?: boolean;

  selectAll: (ids: string[]) => void;
  unselectAll: (ids: string[]) => void;
  applicationOptions: Array<{ label: string; value: string }>;
  groupOptions: Array<{ label: string; value: string }>;
  userOptions: Array<{ label: string; value: string }>;
}

class WorkspacesTableHead extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <TableHead>
                <TableSelectionColumn
                    itemIds={this.props.ids}
                    tableKey="workspaces"
                    selectAll={() => this.props.selectAll(this.props.ids)}
                    deselectAll={() => this.props.unselectAll(this.props.ids)}
                />
                <TableSortableColumn
                    tableKey="workspaces"
                    column="name"
                    refresh={this.props.refresh}
                >
                    {t('workspaces.table.header.name')}
                </TableSortableColumn>
                <TableColumn>
                    {t('workspaces.table.header.parent')}
                </TableColumn>
                <TableSortableColumn
                    tableKey="workspaces"
                    column="user_limit"
                    refresh={this.props.refresh}
                >
                    {t('workspaces.table.header.userLimit')}
                </TableSortableColumn>
                <TableFilterableColumn
                    tableKey="workspaces"
                    columnName={t('workspaces.table.header.applications') as string}
                    filterKey="a"
                    options={this.props.applicationOptions}
                    refresh={this.props.refresh}
                />
                {this.props.hideGroups === false ? (
                    <TableFilterableColumn
                        tableKey="workspaces"
                        columnName={t('workspaces.table.header.groups') as string}
                        filterKey="g"
                        options={this.props.groupOptions}
                        refresh={this.props.refresh}
                    />
                ) : null}
                <TableFilterableColumn
                    tableKey="workspaces"
                    columnName={t('workspaces.table.header.users') as string}
                    filterKey="u"
                    options={this.props.userOptions}
                    refresh={this.props.refresh}
                />
                <TableColumn className="icon-btn-th" />
                <TableColumn className="icon-btn-th" />
            </TableHead>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    applicationOptions: applicationOptions(state),
    groupOptions: groupOptions(state),
    hideGroups: hideGroups(state),
    userOptions: userOptions(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAll: (ids: string[]) => dispatch(selectAll('workspaces', ids)),
  unselectAll: (ids: string[]) => dispatch(unselectAll('workspaces', ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(WorkspacesTableHead));